import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/yinghui_logo.png'
import _imports_1 from '@/assets/home/img_home_next.png'
import _imports_2 from '@/assets/home/top/img_home_xingzheng.png'
import _imports_3 from '@/assets/home/top/img_home_sifa.png'
import _imports_4 from '@/assets/home/top/img_home_yichang.png'
import _imports_5 from '@/assets/home/top/img_home_sanfang.png'


const _withScopeId = n => (_pushScopeId("data-v-623564a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "credit-root hidden-md-and-down" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "credit-root-h-50" }, null, -1))
const _hoisted_3 = { class: "credit-title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "credit-title-top" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "credit-title-top-icon"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "margin-left-10 credit-title-top-text" }, "荧辉数字化服务")
], -1))
const _hoisted_5 = { class: "credit-top-play-text margin-top-30" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "credit-btn-text" }, "了解详情", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "credit-btn-icon margin-left-10"
}, null, -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "credit-root-h-50" }, null, -1))
const _hoisted_10 = { class: "credit-item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-start-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    class: "credit-item-title-icon"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "credit-item-title-text margin-left-15" }, "行政处罚")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "credit-item-text margin-top-20" }, "企业被行政处罚？别忧心！我们的维护服务能迅速处理不良记录影响，还您企业一片清朗信誉天空，助力业务蓬勃发展。", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "credit-item-list margin-top-15" }, "① 警告", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "credit-item-list margin-top-10" }, "② 处以罚金并且公示", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "credit-item-list margin-top-10" }, "③ 没收违法所得", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "credit-item-list margin-top-10" }, "④ 撤销正常营业行为", -1))
const _hoisted_17 = { class: "credit-item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-start-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    class: "credit-item-title-icon"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "credit-item-title-text margin-left-15" }, "司法案件")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "credit-item-text margin-top-20" }, "企业行政处罚维护，争分夺秒！我们以极快速度启动流程，高质量完成维护，让您的企业迅速恢复元气，抢占市场先机。", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "credit-item-list margin-top-15" }, "① 合同纠纷", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "credit-item-list margin-top-10" }, "② 知识产权纠纷", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "credit-item-list margin-top-10" }, "③ 劳动仲裁", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "credit-item-list margin-top-10" }, "④ 环境污染纠纷", -1))
const _hoisted_24 = { class: "credit-item" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-start-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    class: "credit-item-title-icon"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "credit-item-title-text margin-left-15" }, "历史记录处理")
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "credit-item-text margin-top-20" }, "已结案的诉讼记录、已执行完毕的执行案件记录、行政处罚记录、金融信用记录、负面记录，合法快速处理，不留痕迹。", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "credit-item-list margin-top-15" }, "① 诉讼记录", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "credit-item-list margin-top-10" }, "② 历史环保处罚记录", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "credit-item-list margin-top-10" }, "④ 历史税务处罚记录", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "credit-item-list margin-top-10" }, "③ 历史失信被执行人", -1))
const _hoisted_31 = { class: "credit-item" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-start-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    class: "credit-item-title-icon"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "credit-item-title-text margin-left-15" }, "对接各大平台")
], -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "credit-item-text margin-top-20" }, "专家团队对接公示系统、各省、市的信用信息平台、三方企业信息查询平台，快速合法合规为您处理企业不良记录信息。", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "credit-item-list margin-top-15" }, "① 信用中国", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "credit-item-list margin-top-10" }, "② 企业信用信息公示系统", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "credit-item-list margin-top-10" }, "③ 各省、市的信用信息平台", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "credit-item-list margin-top-10" }, "④ 企某查、天某查、启某宝等查询平台", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "credit-root-h-50" }, null, -1))

import {ref, onMounted, computed} from 'vue';
import {AppConfig} from "@/config";
import {isShowQrCodeDialog} from "@/views/data/CommonData";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeCredit',
  setup(__props) {

const onBtnClick = () => {
  isShowQrCodeDialog.value = true
}

// let text = "VUEVUEVUE";
let text = "企业信用快速维护";
let displayedText = ref("");
let index = 0;

const displayTextOneByOne = () => {
  if (index < text.length) {
    if (displayedText.value.length >= text.length) {
      displayedText.value = ""
    }
    displayedText.value += text.charAt(index);
    index++;
    setTimeout(displayTextOneByOne, 200);
  } else if (displayedText.value.length === text.length) {
    index = 0;
    setTimeout(displayTextOneByOne, 2000);
  }
}

onMounted(() => {
  displayTextOneByOne();
});

const textColor = computed(() => {
  return 'red'; // 最后几个字的颜色为红色
});

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_el_row, {
      justify: "center",
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          md: 12,
          span: _unref(AppConfig).span22
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displayedText), (char, index) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: index,
                    style: _normalizeStyle({ color: index < _unref(text).length / 2 ? '#2f2f2f' : '#1b57ec' })
                  }, _toDisplayString(char), 5))
                }), 128))
              ])
            ])
          ]),
          _: 1
        }, 8, ["span"])
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      class: "credit-btn margin-top-30",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (onBtnClick()))
    }, _hoisted_8),
    _hoisted_9,
    _createVNode(_component_el_row, {
      justify: "center",
      gutter: 20,
      style: {"width":"100%"},
      class: "margin-top-15 margin-bottom-50 hidden-md-and-down"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          md: 4,
          span: _unref(AppConfig).span
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _hoisted_12,
              _hoisted_13,
              _hoisted_14,
              _hoisted_15,
              _hoisted_16,
              _createElementVNode("span", {
                class: "credit-item-list-more margin-top-10",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (onBtnClick()))
              }, "更多行政处罚类型")
            ])
          ]),
          _: 1
        }, 8, ["span"]),
        _createVNode(_component_el_col, {
          md: 4,
          span: _unref(AppConfig).span
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _hoisted_19,
              _hoisted_20,
              _hoisted_21,
              _hoisted_22,
              _hoisted_23,
              _createElementVNode("span", {
                class: "credit-item-list-more margin-top-10",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (onBtnClick()))
              }, "更多司法案件类型")
            ])
          ]),
          _: 1
        }, 8, ["span"]),
        _createVNode(_component_el_col, {
          md: 4,
          span: _unref(AppConfig).span
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _hoisted_26,
              _hoisted_27,
              _hoisted_28,
              _hoisted_29,
              _hoisted_30,
              _createElementVNode("span", {
                class: "credit-item-list-more margin-top-10",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (onBtnClick()))
              }, "更多历史记录类型")
            ])
          ]),
          _: 1
        }, 8, ["span"]),
        _createVNode(_component_el_col, {
          md: 4,
          span: _unref(AppConfig).span
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _hoisted_33,
              _hoisted_34,
              _hoisted_35,
              _hoisted_36,
              _hoisted_37,
              _createElementVNode("span", {
                class: "credit-item-list-more margin-top-10",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (onBtnClick()))
              }, "更多对接平台类型")
            ])
          ]),
          _: 1
        }, 8, ["span"])
      ]),
      _: 1
    }),
    _hoisted_38
  ]))
}
}

})